<template>
    <div class="container-mobile bg-white overflow-auto height-fill">
        <div class="content">
            <!-- Header -->
            <div
                class="header d-flex text-black px-3 custom-fs-18 container-390 position-fixed align-items-center justify-content-between" :class="[getAgentType===1?'pth-android':getAgentType===2? 'pth-ios':'']">
                <img role="button" src="@/assets/images/mobile/fi-rr-angle-small-right.svg" alt="back"
                    @click="BackToMain()">
                <div class="mx-auto fw-bold pe-4 fs-22-custom">{{ title_.value }}</div>
            </div>

            <!-- Content -->
            <div class="content-all-points px-3 d-flex flex-column align-items-center text-center ext-links-err-content" :class="[getAgentType===1?'ptc-android':getAgentType===2? 'ptc-ios':'']">
                <img  src="@/assets/images/mobile/error-image.png" class="img-error" alt="success">
                <div class="title text-black mb-3 text-center">{{ local.error_share_1 }}</div>
                <div class="des mb-3 text-center">{{ local.error_share_2 }}</div>
                <button class="go-back-btn rounded-4 mx-auto text-center" @click="reloadPage()">{{ local.external_links_error_page4 }}</button>
            </div>
        </div>
    </div>
</template>

<script>


import { onMounted, computed,reactive  } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { isAndroid, isIOS } from '@/utils/utils'
import { sendMessageToFlutter,reloadPageApi } from '@/api/api'

export default {
    name: 'Error',
    setup() {
        const route = useRoute()
        const router = useRouter()
        const store = useStore()
        const local = computed(() => store.state.translation.locale)
         const getAgentType = computed(()=> {
            if(isAndroid()) return 1;
            else if(isIOS()) return 2;
            else return 0
        })
        const title_ = reactive({
            value: ''
        })
        onMounted(async () => {
            title_.value = route.query.title ?? local.value.share_error
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang })
        })

        const reloadPage = () => {
            reloadPageApi('reloadPage')
            router.back()
        }

        const BackToMain = () => {
            sendMessageToFlutter('clickBack')
        }

        return {
            local,
            reloadPage,
            title_,
            getAgentType,
            BackToMain
        };


    }
}
</script>

<style scoped>
.img-error {
    width: 350px !important;
    margin-bottom: 16px;
}

.title {
    font-size: 36px;
}

.des {
    color: rgba(136, 136, 136, 1);
    font-size: 16px;
}

.go-back-btn {
    color: rgba(64, 128, 252, 1);
    background-color: rgba(64, 128, 252, 0.1);
    border: 1px solid rgba(64, 128, 252, 1);
    width: 100px;
    margin-bottom: 16px;
}

.height-fill {
    height: 100vh;
    background: #EDF0F5 !important;
}
</style>